import React from 'react';

const History = () => {
  return (
    <div>
      <h1>History Component</h1>
      <p>This is a dummy component for the History section.</p>
    </div>
  );
};

export default History;